import Head from 'next/head';
import Image from 'next/image';
import styles from '../../styles/sass/pages/Service.module.scss'
import useWindowSize from '../../util/useWindowSize'

export default function GroupConsueling() {
    const size = useWindowSize();

    return (
        <>
            <Head>
                <title>Szolgáltatások - Csoport | Szabó Jennifer Pszichológus</title>
                <meta name="description"
                    content="A csoportos önismeret lehetőséget teremt önmagunk mélyebb megismerésére másokon keresztül." />
                <meta property="og:title" content="Szolgáltatások - Csoport | Szabó Jennifer Pszichológus" />
                <meta property="og:type" content="article" />
                <meta property="og:description"
                    content="A csoportos önismeret lehetőséget teremt önmagunk mélyebb megismerésére másokon keresztül." />
                <meta property="og:url" content="https://szabojennifer.hu/szolgaltatasok/csoport" />
                <meta property="og:image" content="/img/szolgaltatasok/csoportos-onismeret-hero.png" />
                <meta property="og:image:alt" content="Körben elhelyezett üres székek" />
            </Head>
            <main>
                <div className={styles.serviceHeroContainer}>
                    <div className={styles.serviceHero}>
                        <div className={styles.serviceImageSide}>
                            <div className={styles.serviceImageContainer}>
                                <Image
                                    src="/img/szolgaltatasok/csoportos-onismeret-hero.png"
                                    className={styles.heroImg}
                                    width={825}
                                    height={550}
                                    alt="Körben elhelyezett üres székek"
                                />
                                <div className={styles.serviceHeadingSide}>
                                    <h1 className={styles.serviceHeading}>
                                        Csoport
                                    </h1>
                                    {size.width > 1344 &&
                                        <>
                                            <p className={styles.serviceHeadingLead}>
                                                A csoportmódszer egyedülálló lehetőséget teremt az önmagunkra való reflektálásra.
                                                A csoport minden tagjával való találkozásban megtapasztalhatjuk a sorsközösség megtartó erejét és az egyetemesség élményét,
                                                ahogy Irvin D. Yalom is mondja: „nincs olyan emberi tett vagy gondolat, ami teljesen idegen lenne mások tapasztalatától.”
                                                A saját tapasztalatainkat, kérdéseinket, nehézségeinket a csoport képes más és más megvilágításba helyezni,
                                                ezzel is szélesítve önmagunkról, másokról és a világról alkotott képünket, támogatja a nézőpontváltást, az átkeretezést.
                                                Biztonságos hely az elfogadás, a kapcsolódás, a visszajelzések és persze saját működésünk gyakorlására.

                                            </p>
                                            <p className={styles.serviceHeadingLead}>
                                                A csoportot – függetlenül annak témájától, felépítéséből – mindig a csoporttagok teszik azzá, amivé végül válik.
                                            </p>
                                        </>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                    {size.width < 1344 &&
                        <div className={styles.serviceHeadingSideMobile}>
                            <p className={styles.serviceHeadingLead}>
                                A csoportmódszer egyedülálló lehetőséget teremt az önmagunkra való reflektálásra.
                                A csoport minden tagjával való találkozásban megtapasztalhatjuk a sorsközösség megtartó erejét és az egyetemesség élményét,
                                ahogy Irvin D. Yalom is mondja: „nincs olyan emberi tett vagy gondolat, ami teljesen idegen lenne mások tapasztalatától.”
                                A saját tapasztalatainkat, kérdéseinket, nehézségeinket a csoport képes más és más megvilágításba helyezni,
                                ezzel is szélesítve önmagunkról, másokról és a világról alkotott képünket, támogatja a nézőpontváltást, az átkeretezést.
                                Biztonságos hely az elfogadás, a kapcsolódás, a visszajelzések és persze saját működésünk gyakorlására.

                            </p>
                            <p className={styles.serviceHeadingLead}>
                                A csoportot – függetlenül annak témájától, felépítéséből – mindig a csoporttagok teszik azzá, amivé végül válik.
                            </p>
                        </div>
                    }
                </div>
                <section className={styles.groupTypeSection}>
                    <div className={styles.groupTypeListContainer}>
                        <div className={styles.groupType}>
                            <div className='p-8'>
                                <h2 className={`${styles.headingSecondary} ${styles.groupTypeHeading}`}>
                                    Önismereti csoport
                                </h2>
                                <p>
                                    Az életünkben nap mint nap kapcsolódunk másokhoz, amik gyakran konfliktusokkal átitatottak.
                                    Egy csoportélmény során megtapasztalhatjuk önmagunkat a másokkal való működésünk relációjában a csoportvezető által hozott módszerek, gyakorlatok mentén.
                                    Az önismereti csoportok során az életvezetést érintő fontos témákat célozzuk meg a csoport felépítésétől függően globálisan vagy esetlegesen tematikusan.
                                </p>
                            </div>
                        </div>
                        <div className={styles.groupType}>
                            <div className='p-8'>
                                <h2 className={`${styles.headingSecondary} ${styles.groupTypeHeading}`}>
                                    Irodalomterápia
                                </h2>
                                <p>
                                    Az irodalomterápia egy olyan művészetterápiás módszer, amely általunk alkotott vagy már létező szövegeket emel be a segítői kapcsolatba az önismeret gazdagítására és a fejlődés elősegítésére.
                                    Nem az a fontos, mit gondolt a szerző, nem a szöveg szépirodalmi értéke a döntő, hanem az, hogy milyen érzések, gondolatok mozdulnak meg bennünk.
                                    A szöveg a csoport és a csoportvezető közötti interakcióban lesz azzá, amire az „itt és most”-ban szükség lehet.
                                </p>
                            </div>
                        </div>
                        <div className={styles.groupType}>
                            <div className='p-8'>
                                <h2 className={`${styles.headingSecondary} ${styles.groupTypeHeading}`}>
                                    Workshop, tréning
                                </h2>
                                <p>
                                    Csoportfoglalkozások egyéneknek vagy adott közösségeknek, amik során egy konkrét témát, problémakört járunk körbe.
                                    Célja lehet egy konkrét problémakör körbejárása, egy adott kompetencia vagy készség fejlesztése. Lehetőséget ad arra is,
                                    hogy először akár hosszabbtávú elköteleződés nélkül megismerjünk egy módszert vagy betekintést nyerjünk a csoportos működés világába.
                                </p>
                            </div>
                        </div>
                    </div>
                </section>

            </main>
        </>
    )
}
